import {convertObjectToGraphQLQueryString} from '../../utils/graphqlUtils.js'
export function preArrivalChecklistFormSubmission (form) {

  const query = `mutation{
    createPreArrivalChecklistForm(data: ${convertObjectToGraphQLQueryString(form)}){
      isSuccess
      errors {
        code
        message
        field
      }
    }
  }`
  return query
}